import * as React from 'react';

import { INavigationProps } from '../../stores/INavigationProps';


class Tenants extends React.Component<INavigationProps> {
    
    public render() {
        return (
            <div className={this.props.active ? '' : 'hidden'} />
        )
    }
}

export default Tenants;